import React from 'react';
import { PhoneCall, CalendarClock, XCircle, Star, MapPin } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation, useNavigate } from 'react-router-dom';
const AppointmentCard = () => {
  const location = useLocation();
  const consultation = location.state?.consultation || null;
  const doctorData = consultation?.doctor || consultation?.doctor_ || {};
  const styles = {
    backArrow: {
      cursor: 'pointer',
      fontSize: '20px',
      color: '#000',
    },
  };

  const handleMouseEnter = (event) => {
    event.currentTarget.style.color = '#000';
  };

  const handleMouseLeave = (event) => {
    event.currentTarget.style.color = '#000';
  };

  const doctor = {
    name: doctorData?.name || 'Dr. Marjorie Black',
    specialty: doctorData?.specialty || doctorData?.specialisation || 'Neurologist',
    rating: doctorData?.rating || doctorData?.averageRating || 4.5,
    reviews: doctorData?.reviews || 500,
    distance: doctorData?.distance || '500m',
    date: consultation?.appointmentTime
      ? new Date(consultation.appointmentTime).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })
      : 'January 23, 2025',
    time: consultation?.appointmentTime
      ? new Date(consultation.appointmentTime).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
      : '10:00 AM',
    avatar: doctorData?.avatar || doctorData?.photo || 'https://randomuser.me/api/portraits/women/44.jpg',
  };
  const navigate = useNavigate();

  const handleJoinCall = () => {
    if (!consultation) {
      navigate('/appoint');
      return;
    }

    const normalizedAppointment = {
      ...consultation,
      consultationId: consultation?.consultationId || consultation?._id || consultation?.id,
      roomId:
        consultation?.roomId ||
        consultation?.consultationRoomId ||
        consultation?.room ||
        consultation?._id ||
        consultation?.id,
      doctor_: consultation?.doctor_ || consultation?.doctor || null,
      doctorId:
        consultation?.doctorId ||
        consultation?.doctor?._id ||
        consultation?.doctor_?._id ||
        consultation?.doctor,
      patientId:
        consultation?.patientId ||
        consultation?.patient?._id ||
        consultation?.patient_?._id ||
        consultation?.patient,
      patientName:
        consultation?.patientName ||
        consultation?.patient?.name ||
        consultation?.patient_?.name ||
        consultation?.fullName ||
        'Patient',
    };

    navigate('/pre-join', { state: normalizedAppointment });
  };

  return (
    <div
      className="container py-4"
      style={{
        maxWidth: 480,
     
      }}
    >

           <i 
          className="fi fi-br-angle-left"
          onClick={() => navigate(-1)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={styles.backArrow}
        ></i>

           <br/>
           <br/>
      <div
        className="card-theme shadow-sm border-0 rounded-4 p-3"
        style={{
          background: 'linear-gradient(135deg, rgba(127, 0, 255, 0.10), #ffffff)',
          border: '1px solid rgba(127, 0, 255, 0.14)',
             bottom : "50%"
        }}
      >
        {/* Doctor Info */}
        <div className="d-flex align-items-center mb-3">
          <img
            src={doctor.avatar}
            alt={doctor.name}
            className="rounded-circle me-3 shadow-sm"
            style={{
              width: 70,
              height: 70,
              objectFit: 'cover',
              border: '3px solid #e0e0e0',
            }}
          />
          <div className="flex-grow-1">
            <h5 className="fw-semibold mb-1">{doctor.name}</h5>
            <p className="text-muted mb-1" style={{ fontSize: 13 }}>
              {doctor.specialty} •{' '}
              <Star size={13} className="text-warning me-1" />
              {doctor.rating}★ ({doctor.reviews})
            </p>
            <p className="text-muted mb-0 d-flex align-items-center" style={{ fontSize: 13 }}>
              <MapPin size={13} className="me-1 text-muted" />
              {doctor.distance} away
            </p>
          </div>
        </div>

        <hr className="my-3" />

        {/* Appointment Info */}
        <div className="text-center mb-3">
          <p className="mb-1 text-muted" style={{ fontSize: 13 }}>
            Upcoming Appointment
          </p>
          <h6 className="fw-semibold mb-0">
            {doctor.date} • {doctor.time}
          </h6>
        </div>

        {/* Buttons */}
        <div className="d-flex flex-column gap-2 mt-3">
          <button
            className="btn d-flex justify-content-center align-items-center gap-2 py-2 rounded-4 fw-semibold shadow-sm"
            style={{ fontSize: 14, backgroundColor: 'var(--primary)', borderColor: 'var(--primary)', color: '#fff' }}
            onClick={handleJoinCall}
          >
            <PhoneCall size={18} />
            Join Call
          </button>
          <button
            className="btn d-flex justify-content-center align-items-center gap-2 py-2 rounded-4 fw-semibold shadow-sm"
            style={{ fontSize: 14, backgroundColor: 'var(--primary)', borderColor: 'var(--primary)', color: '#fff', opacity: 0.92 }}
            onClick={() => {
              if (!consultation) {
                navigate('/appoint');
                return;
              }
              navigate('/reschedule', { state: { consultation } });
            }}
          >
            <CalendarClock size={18} />
            Reschedule
          </button>
          <button
            className="btn btn-outline-danger d-flex justify-content-center align-items-center gap-2 py-2 rounded-4 fw-semibold shadow-sm"
            style={{ fontSize: 14 }}
            onClick={() => {
              if (!consultation) {
                navigate('/appoint');
                return;
              }
              navigate('/cancel', { state: { consultation } });
            }}
          >
            <XCircle size={18} />
            Cancel Appointment
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppointmentCard;
